module.exports = __webpack_public_path__ + "img/ipad-en-10.2489015.jpg";